<style>
  table {
    border: 1px solid black !important;
  }

  tr:nth-child(even) {
    background-color: #e6e6e663 !important;
  }

  .landscaperSummaryTable tr:nth-child(even) {
    background-color: #e6e6e663 !important;
  }

  .designerSec6SummaryHeaderCol {
    min-width: 35px !important;

  }

  .whiteSpace {
    white-space: pre-line;
  }

  @media screen and (min-width: 1201px) {

    .toolReportSummaryTable {
      width: 25%;
    }

    .toolReportTOC {
      width: 50%;
    }
  }

  @media screen and (min-width: 1025px) and (max-width: 1200px) {

    .toolReportSummaryTable {
      width: 25%;
    }

    .toolReportTOC {
      width: 50%;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1024px) {

    .toolReportSummaryTable {
      width: 25%;
    }

    .toolReportTOC {
      width: 50%;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991.98px) {
    .toolReportSummaryTable {
      width: 25%;
    }

    .toolReportTOC {
      width: 50%;
    }
  }

  @media screen and (min-width: 576px) and (max-width: 767.98px) {

    .toolReportSummaryTable {
      width: 30%;
      min-width: 150px;
    }

    .toolReportTOC {
      width: 90%;
    }
  }

  @media screen and (max-width: 575.98px) {
    .toolReportSummaryTable {
      width: 30%;
      min-width: 150px;
    }

    .toolReportTOC {
      width: 90%;
    }
  }

  .levelwise tr:nth-child(even) {
    background-color: transparent !important;
  }

  thead {
    font-weight: bold !important;
  }

  .textAlignCenter {
    text-align: center !important;
  }

  p {
    margin: 0px !important;
  }

  tr th {
    border: 1px solid black !important;
  }

  .summaryTable {
    width: 25% !important;
    text-align: right;
  }

  .table-bordered tbody tr>th,
  .table-bordered thead tr>th {
    font-weight: 700 !important;
  }

  .table-bordered>tbody>tr>td,
  .table-bordered>tbody>tr>th,
  .table-bordered>tfoot>tr>td,
  .table-bordered>tfoot>tr>th,
  .table-bordered>thead>tr>td,
  .table-bordered>thead>tr>th {
    border: 1px solid black;
  }

  .textalignleft {
    text-align: left !important;
  }

  .textalignright {
    text-align: right !important;
  }
</style>
<div class="login" style="overflow: auto">
  <button class="btn btn-primary" (click)="scrollToTopFunction()" id="scrollToTpBtn" title="Go to top">
    <i class="fas fa-caret-up fa-2x"></i>
  </button>
  <header class="pt-0 pb-0">
    <nav class="">
      <div class="align_left">
        <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
      </div>
      <div>
      </div>
      <div class="align_right">
        <button class="btn btn-downloadprimary" (click)="printWindow()">{{ 'cockpitReport.print' | translate }}</button>
      </div>
    </nav>
  </header>
  <div class="row strict content cursorArrow">
    <div class="well mb-0" id="sourceData">
      <div class="row strict" *ngIf="toolReportName != 'Checklist'">
        <h3>[{{projectName}}]</h3>
        <h4>
          {{toolReportName}} / {{currentDate | date:'mediumDate' }}</h4>
      </div>
      <div class="row strict" *ngIf="toolReportName == 'Checklist'">
        <h3>{{toolReportName}}</h3>
        <h4 *ngIf="checklistType == 'public'">[{{projectName}}]</h4>
      </div>
      <div class="row strict">
        <span id="entityDetails"></span>
      </div>
      <div class="list-group toolReportTOC fontsize12px">
        <span id="contentlist"></span>
      </div>
      <div class="row strict cursorArrow">
        <div class="col-md-12">
          <span id="exportSheet"></span>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <p class="copyright cursorArrow">
      {{ 'cockpitReport.generatedBy' | translate }} {{userName}} {{ 'cockpitReport.on' | translate }}
      {{currentDate | date:'MMM d, y h:mm a' }}&nbsp;IST&nbsp;on doSmartQA
    </p>
  </footer>
</div>